import {
  Table,
  TableContainer,
  TableCaption,
  Tr,
  Th,
  Td,
  Tbody,
  Thead,
} from "@chakra-ui/react";

const GameTable = () => {
  return (
    <TableContainer m={10} w={"max-content"}>
      <Table variant="simple" size="md">
        <TableCaption>Game point values of each card</TableCaption>
        <Thead>
          <Tr>
            <Th>Card</Th>
            <Th>Game Point Value</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Tens</Td>
            <Td>10</Td>
          </Tr>
          <Tr>
            <Td>Jacks</Td>
            <Td>1</Td>
          </Tr>
          <Tr>
            <Td>Queens</Td>
            <Td>2</Td>
          </Tr>
          <Tr>
            <Td>Kings</Td>
            <Td>3</Td>
          </Tr>
          <Tr>
            <Td>Aces</Td>
            <Td>4</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};
export default GameTable;
